import React from "react";
import Picker from "@emoji-mart/react";

export interface EmojiData {
    id: string;
    shortcodes: string;
    native: string;
    aliases: string[];
    emoticons: string[];
    name: string;
    keywords: string[];
    unified: string;
}

export interface EmojiPickerProps {
    readonly onEmojiSelect?: (emoji: EmojiData) => void;
}
export function EmojiPicker(props: EmojiPickerProps) {
    return (
        <Picker
            data={async () => {
                const response = await fetch("https://cdn.jsdelivr.net/npm/@emoji-mart/data");

                return response.json();
            }}
            onEmojiSelect={props.onEmojiSelect}
            autoFocus={true}
        />
    );
}
